import { useState, useCallback } from "react";
import Help from "./Help";
import UpdatingLibraryDialog from "./UpdatingLibraryDialog";
import useUpdateLibrary from "../../actions/update-library/useUpdateLibrary";

export default function HelpDialogSwitcher({
  onRequestClose,
}: {
  onRequestClose: () => void;
}) {
  const [activeDialog, setActiveDialog] = useState<"help" | "updating-library">(
    "help"
  );
  const [updateLibrary, fetcher] = useUpdateLibrary();

  const onUpdateLibrary = useCallback(() => {
    updateLibrary();
    setActiveDialog("updating-library");
  }, [updateLibrary, setActiveDialog]);

  if (activeDialog === "help") {
    return (
      <Help onRequestClose={onRequestClose} onUpdateLibrary={onUpdateLibrary} />
    );
  }

  if (activeDialog === "updating-library") {
    return (
      <UpdatingLibraryDialog
        onRequestClose={onRequestClose}
        fetcher={fetcher}
      />
    );
  }
}
